import React, { useEffect, useState } from "react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import AudioBtn from "./AudioBtn";

interface AudioControllInput {
    transcriptoutput: React.Dispatch<React.SetStateAction<string>>
}


export default function AudioControl(input: AudioControllInput) {

    let [recordingStatus, recordingStatusUpdate] = useState(false)
    const {
        transcript,
        resetTranscript,
        listening,
        finalTranscript,
        browserSupportsSpeechRecognition,
        isMicrophoneAvailable
    } = useSpeechRecognition({ transcribing: recordingStatus, clearTranscriptOnListen: true });


    function onStart() {
        SpeechRecognition.startListening({ language: "it-IT", continuous: true })
    }

    function onStop() {
        SpeechRecognition.stopListening()
    }
    function onReset() {
        resetTranscript()

    }
    function onChangeManualInput(event: React.ChangeEvent<HTMLInputElement, HTMLInputElement>) {
        input.transcriptoutput(event.currentTarget.value)
    }

    useEffect(() => {
        input.transcriptoutput(finalTranscript)
    }, [finalTranscript])


    if (!browserSupportsSpeechRecognition || !browserSupportsSpeechRecognition) {
        return <div>
            <span>Browser doesn't support speech recognition.</span>
            <div>
                <label htmlFor="inputText">Manual input </label>
                <input id="inputText" onChange={onChangeManualInput}
                    autoComplete="off" />
            </div>
        </div>;
    }
    if (!isMicrophoneAvailable) {
        return <div>
            <span>Microphone not found</span>
            <div>
                <label htmlFor="inputText">Manual input </label>
                <input id="inputText" onChange={onChangeManualInput}
                    autoComplete="off" />
            </div>
        </div>;
    }

    return (
        <div>
            <p>Microphone: {listening ? 'on' : 'off'}</p>
            <div>
                <AudioBtn audiostatus={recordingStatus}
                    updateAudio={recordingStatusUpdate}
                    start={onStart}
                    stop={onStop} />
                <button onClick={onReset} >Reset</button>
            </div>
            <div>
                <label htmlFor="inputText">Manual input </label>
                <input id="inputText" onChange={onChangeManualInput}
                    autoComplete="off" />
            </div>
        </div>
    );

}